import { put, takeLatest } from "redux-saga/effects";
import { call, select } from "redux-saga/effects";
import { modifyGiftGroupsApi } from "../../../axios/gift-list";
import { modifyGiftGroupsAction } from "../../../constants";
import { selectShownGiftGroupsById, selectToken } from "../../selectors";
import { SagaIterator } from "redux-saga";
import * as actions from "../../actions";
import { GiftGroup, GiftItem, ModifyGiftGroupsPayload } from "../../../types";
import { notify } from "react-notify-toast";
import Strings from "../../../i18n/strings/giftList";
import { translate } from "../../../helpers/translate";

const t = translate("giftList");

function* modifyGiftGroupsSaga(): SagaIterator {
  try {
    const token = yield select(selectToken);
    const shownGiftGroupsById = yield select(selectShownGiftGroupsById);
    const payload: ModifyGiftGroupsPayload = {
      groups: Object.values(
        shownGiftGroupsById as Record<string, GiftGroup>
      ).map((group) => ({
        id: group.id,
        name: group.name,
        ar_name: group.ar_name,
        is_ar_renamed: group.is_ar_renamed || 0,
        price: group.price,
        is_renamed: group.is_renamed || 0,
        items: (group.items as GiftItem[]).map((item) => ({
          id: item.id,
          order: item.order,
        })),
      })),
    };
    if (payload.groups.length < 3) {
      notify.show(t(Strings.atLeastThreeGiftGroupsRequired), "error");
      yield put(
        actions.modifyGiftGroupsFailure(
          new Error(t(Strings.atLeastThreeGiftGroupsRequired))
        )
      );
      return;
    }
    yield call(modifyGiftGroupsApi, token, payload);
    yield put(actions.modifyGiftGroupsSuccess(payload.groups));
    notify.show(t(Strings.giftGroupsUpdatedSuccessfully), "success");
  } catch (e) {
    yield put(actions.modifyGiftGroupsFailure(e as Error));
    notify.show(t(Strings.failedToUpdateGiftGroups), "error");
  }
}

export function* watchModifyGiftGroupsSaga(): SagaIterator {
  yield takeLatest(modifyGiftGroupsAction.requested, modifyGiftGroupsSaga);
}
